import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

const rubyType = 'claim'
const storeType = 'claims'

export const PEClaimsCardActions = {
  initPeClaimsCard: ({ commit }, index) => {
    commit('setPeClaimsCardLock', { index, lock: true })
  },
  peFetchClaimsCards: async ({ commit, getters, dispatch }) => {
    const party = getters.peParty
    return axiosRequest.
      get(`/parties/${party.id}/asylum_assistants`, { params: { type: rubyType } }).
      then(({ data }) => {
        const assistantCards = data?.asylum_assistant
        commit('pePatchAsylumAssistantList', {
          assistant: storeType,
          list: assistantCards || [],
        })
      })
  },
  peClaimsCardCreate: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      post(`/parties/${party.id}/asylum_assistants`, {
        asylum_assistant: {
          type: rubyType,
          value: {
            harm_type: section.harm_type,
            harm_description: section.harm_description,
            agent_description: section.agent_description,
            motive_description: section.motive_description,
            basis_of_race: section.basis_of_race,
            basis_of_religion: section.basis_of_religion,
            basis_of_particular_social_group: section.basis_of_particular_social_group,
            basis_of_nationality: section.basis_of_nationality,
            basis_of_political_opinion: section.basis_of_political_opinion,
            narrative: section.narrative,
          },
        },
      }).
      then(({ data }) => {
        const updatedAssistantCards = data?.asylum_assistant

        commit('setPeClaimsCardLock', { index, lock: true })
        commit('pePatchAsylumAssistantList', {
          assistant: storeType,
          list: updatedAssistantCards || [],
        })
      }).
      catch(handleError)
  },
  peClaimsCardRefresh: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty
    return axiosRequest.
      get(`/parties/${party.id}/asylum_assistants/${section.id}`, { params: { type: rubyType } }).
      then(({ data }) => {
        commit('setPeClaimsCardLock', { index, lock: true })
        commit('pePatchAsylumAssistant', {
          assistant: storeType,
          value: data,
        })
      }).
      catch(handleError)
  },
  peClaimsCardUpdate: async ({ commit, getters }, { id, section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      patch(`/parties/${party.id}/asylum_assistants/${id}`, {
        asylum_assistant: {
          type: rubyType,
          value: {
            harm_type: section.harm_type,
            harm_description: section.harm_description,
            agent_description: section.agent_description,
            motive_description: section.motive_description,
            basis_of_race: section.basis_of_race,
            basis_of_religion: section.basis_of_religion,
            basis_of_particular_social_group: section.basis_of_particular_social_group,
            basis_of_nationality: section.basis_of_nationality,
            basis_of_political_opinion: section.basis_of_political_opinion,
            narrative: section.narrative,
          },
        },
      }).
      then(({ data }) => {
        const updatedAssistantCards = data?.asylum_assistant

        commit('setPeClaimsCardLock', { index, lock: true })
        commit('pePatchAsylumAssistantList', {
          assistant: storeType,
          list: updatedAssistantCards || [],
        })
      }).
      catch(handleError)
  },
  peClaimsCardDelete: async ({ commit, getters }, { id, index }) => {
    const party = getters.peParty

    return axiosRequest.
      delete(`/parties/${party.id}/asylum_assistants/${id}`, { params: { type: rubyType } }).
      then(({ data }) => {
        const updatedAssistantCards = data?.asylum_assistant

        commit('setPeClaimsCardLock', { index, lock: true })
        commit('pePatchAsylumAssistantList', {
          assistant: storeType,
          list: updatedAssistantCards || [],
        })
      }).
      catch(handleError)
  },
  peClaimsCardAddSection: ({ commit }) => {
    commit('setPeClaimsCardLock', { index: 'new', lock: false })
    commit('addPeClaimsCardSection', {
      id: null,
      harm_type: '',
      harm_description: '',
      agent_description: '',
      motive_description: '',
      basis_of_race: false,
      basis_of_religion: false,
      basis_of_particular_social_group: false,
      basis_of_nationality: false,
      basis_of_political_opinion: false,
      narrative: '',
    })
  },
  peClaimsCardDownloadPDF: async ({ getters }, { legalCaseId }) => {
    const party = getters.peParty

    return await axiosRequest.
      post(`/parties/${party.id}/asylum_assistant_download`, { asylum_assistant: { legal_case_id: legalCaseId } }).
      then(({ data }) => data).
      catch(handleError)
  },
}

export const PEClaimsCardMutations = {
  setPeClaimsCardLock: (state, { index, lock }) => {
    if (!state.partyEdit.partySections.ClaimsCard) Vue.set(state.partyEdit.partySections, 'ClaimsCard', {})
    Vue.set(state.partyEdit.partySections.ClaimsCard, index, lock)
  },
  addPeClaimsCardSection: (state, section) => state.partyEdit.asylumAssystant[storeType].push(section),
  peClaimsCardCreateUndo: state => state.partyEdit.asylumAssystant[storeType].pop(),
}

export const PEClaimsCardGetters = {
  peClaimsCardLock: state => index => state.partyEdit.partySections.ClaimsCard[index],
  peClaimsCardHasNewSection: state => !!state.partyEdit.asylumAssystant[storeType]?.find(aka => aka.id === null),
}
